export default __webpack_public_path__ + "static/media/20.55b7eb37.png";